import React, { useState } from 'react';
import styled from "styled-components";
import { Tooltip, Modal ,Input,Form, Button,} from 'antd';
import { useAuth } from "@/component/Auth";
import { LOGININFOSTORE, LOGINTOKEN, APKNAME, RECORD_SERVER } from "@/config/const";
import Alink, { Link } from "@/component/Alink";
import { usePage } from "@/component/PageControl";
import { SettingOutlined ,NotificationOutlined} from "@ant-design/icons";
import { Badge, message } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import prompt from "antd-prompt";
import { users } from "@/api";
import isElectron from "is-electron";
import { storage } from "@/util";
import * as consts from "@/config/const";
import NumericInput from "../component/MyInput/MyInput";
import AboutModal from './aboutModal';
import ContactModal from './contact';
import Default_Avatar from '../assets/avatar.jpg'
import MeetingLogo from '../assets/logo/generic-meeting.svg';
export const MainContent = styled.div`
  flex: 1;
  display: flex;
`;

const LeftContainer = styled.div`
  width: 200px;
  height: 100%;
  background: #eee;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  flex-shrink: 0;
  .logo {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 25px;
    font-size: 18px;
    font-weight: 500;
    gap: 10px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  .userinfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    .avatar {
      background: rgba(255, 255, 255, 0.45);
      width: 90px;
      height: 90px;
      overflow: hidden;
      border-radius: 45px;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 22px;
      font-weight: bold;
      object-fit: cover;
    }
    .username {
      margin-top: 10px;
      font-size: 14px;
    }
  }
  .alink {
    padding: 6px;
  }
  .bottom {
    position: absolute;
    width: 200px;
    bottom: 0;
    left: 0;
    height: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }
`;

const ___navlinks = [
  { to: "/", txt: "加入会议" },
  { to: "/main/quick", txt: "快速会议" },
  { to: "/main/appointment", txt: "预约会议" },
  { to: "/main/manage", txt: "会议管理" },
  { to: "/main/history", txt: "历史会议" },
  // { to: "/main/contacts", txt: "通讯录" },
];
 
 
const MainLeftMenu: React.FunctionComponent = () => {
 
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [webLinkStatus, setWebLinkStatus] = useState(true)

  const [mvalue, setMvalue] = useState('');
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState('Content of the modal');
  const auth = useAuth();
  const location = useLocation();
  const history = useHistory();
  const { loggedIn, loginfo, updateLogInfo } = auth;

  const page = usePage();
  const { goSetting, currentLink } = page;

  const Avatar = () =>
    loggedIn && loginfo.avatar ? (
      // <img className="avatar" src={loginfo.avatar} alt={loginfo.virtualNum} />
      <img className="avatar" src={Default_Avatar} alt={loginfo.virtualNum} />
      ) : null;
    const exitlogin = () => {
      storage.remove(LOGININFOSTORE);
      storage.remove(LOGINTOKEN);
      if (isElectron()) {
        alert(`推出登陆!`);
        history.replace("/");
      } else {
        window.location.href = "/";
      }
    };
  // const Avatar = () =>
  //     <img className="avatar" src={suhang} alt="" />;

  React.useEffect(() => {
    if (!loggedIn) {
      const { pathname } = location;
      if (
        !/reg|login|join|losepass/.test(pathname) || pathname !== "/"
      ) {
        console.log("auto logoin FAIL")
        history.replace("/");
      } else {
        console.log("auto logoin success")
        const isAutoLogin = localStorage.getItem('autoLogin');
        console.log("is  autoLogin???:"+isAutoLogin)
        if(!isAutoLogin){
          console.log("not  isAutoLogin !!!!!!!!!! exitlogin")
          exitlogin()
        }
      }
    }
  }, [loggedIn]);

  React.useEffect(()=>{
    const checkStorage = () => {
      // 检查storage变化的逻辑
      setWebLinkStatus(storage.get( consts.WebLinkStatus))
       
      //console.log("WebLinkStatus::",webLinkStatus)
    };
     

    const intervalId = setInterval(checkStorage, 3000); // 每3秒检查一次

    return () => {
        clearInterval(intervalId);
    };
  },[ ])
  React.useEffect(() => {
    const info = storage.get(LOGININFOSTORE);
    if (info.userId) {
      auth.updateLogInfo(info);
    }
  }, []);

  const updateName = async (nickname: string) => {
    const { avatar: headimage, email, enterpriseName: department } = loginfo;
    await users.userinfoupdate({ nickname, headimage, email, department });
    updateLogInfo({ realName: nickname });
    message.success("修改完毕");
  };
 

  const nameClickHandler = () => {
    if (!loggedIn) return;

    form.setFieldsValue({ input: loginfo.realName });
    setIsModalVisible(true);
  };
  

  const nameClicOK = async () => {
    try {
      const values = await form.validateFields();
      const name = values.input;
      await updateName(name);
      setIsModalVisible(false);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const handleName = () => {
    setIsModalVisible(false);
  };

  // const nameClickHandler = async () => {
  //   console.log('修改用户名')
  //   if (!loggedIn) return;

  //   try {
  //     const name = await prompt({
  //       title: "输入新名字",
  //       value: loginfo.realName,
  //       placeholder: "请输入新名字",
  //       rules: [
  //         {
  //           required: true,
  //           message: "请输入新名字",
  //         },
  //       ],
  //       modalProps: {
  //         width: "400px",
  //       },
  //     });
  //     updateName(name);
  //   } catch (e) {
  //     console.log("Please enter name");
  //   }
  // };
  const showModal=()=>{
    setOpen(true);
  }
  const handleOk = () => {
    setConfirmLoading(true);
    // 这里添加你的确认操作代码
    setConfirmLoading(false);
    setOpen(false);
  };
  
  const handleCancel = () => {
    setOpen(false);
  };
 
  const [showAbout, setShowAbout] = React.useState(false);
  const [showContact, setShowContact] = React.useState(false);
  
  const menu = [
    {
      label: "关于我们",
      callback: () => setShowAbout(true),
      auth: true
    },
    {
      label: "联系我们",
      callback: () => setShowContact(true),
      auth: true
    },
    {
      label: "退出登录",
      callback: () => exitlogin(),
      auth: true
    }
  ]
 
  return (
    <LeftContainer>
      <div className="logo">
        <img src={MeetingLogo} alt="视频会议" />
        <span>视频会议</span>
      </div>
      <div className="userinfo">
        <Avatar />
        <div
          className={`username ${loginfo.realName ? "pointer" : ""}`}
          onClick={nameClickHandler}
        >
          {loginfo.realName || "请登录"}
        </div>
      </div>
      {!loggedIn && (
        <>
          <Alink
            className="alink"
            to="/login"
            active={currentLink === "/login"}
            disabled={false}
          >
            登录
          </Alink>
          <Alink
            className="alink"
            to="/"
            active={currentLink === "/"}
            disabled={false}
          >
            加入会议
          </Alink>
        </>
      )}
      {loggedIn &&
        ___navlinks.map((t) => (
          <Alink
            className="alink"
            key={t.to}
            to={t.to}
            disabled={!loggedIn}
            active={currentLink === t.to}
          >
            {t.txt}
          </Alink>
        ))}
      {
        loggedIn && loginfo.username === 'admin' && (
          <Alink
            className="alink"
            to="/main/users"
            active={currentLink === "/main/users"}
            disabled={!loggedIn}
          >
            用户管理
          </Alink>
        )
      }
      {
        menu.map((item, index) => (
          item.auth && !loggedIn ? null : (<Link key={index}
              className="alink"
              onClick={item.callback}
            >
              {item.label}
            </Link>)
        ))
      }
      <div className="bottom">
        <div className="status">
          <Badge status="success" />
          { webLinkStatus ? <span>服务器已连接</span> : <span>服务器未连接</span>}
         
        </div>
        <SettingOutlined onClick={goSetting} /> 
      </div>

      <Modal
        title="输入新的昵称"
        visible={isModalVisible}
        onOk={nameClicOK}
        onCancel={handleName}
        okText="确认"
        cancelText="取消"
        width={400}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="input"
            label="新的昵称"
            rules={[
              {
                required: true,
                message: "请输入新的昵称",
              },
            ]}
          >
            <Input placeholder="请输入新的昵称" />
          </Form.Item>
        </Form>
      </Modal>

      <AboutModal visible={showAbout} afterClose={() => setShowAbout(false)} />
      <ContactModal
        visible={showContact}
        afterClose={() => setShowContact(false)}
      />

    </LeftContainer>
  );
};

export default MainLeftMenu;
